module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('progress-bar', {
    ref: "pbar",
    attrs: {
      "pclass": "progress2"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-lotes-leilao table table-clicked table-striped bg-white b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'numero'
    },
    staticStyle: {
      "width": "60px"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('numero')
      }
    }
  }, [_vm._v("\n        LT "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['numero'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'titulo'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('titulo')
      }
    }
  }, [_vm._v("\n        DESCRIÇÃO "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['titulo'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'leilao'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('leilao')
      }
    }
  }, [_vm._v("\n        LEILÃO "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['leilao'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'comitente'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('comitente')
      }
    }
  }, [_vm._v("\n        COMITENTE "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['comitente'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'arremate'
    },
    staticStyle: {
      "width": "120px"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('arremate')
      }
    }
  }, [_vm._v("ARREMATE "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['arremate'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredData), function(lote) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(lote.numero))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-print"
    }, [_c('img', {
      attrs: {
        "width": "50",
        "src": lote.urlMin
      }
    })]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'lotes.visualizar',
          params: {
            leilao: lote.leilao,
            id: lote.id
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(lote.titulo.toUpperCase()) + "\n        ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(lote.leilaoTitulo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lote.comitente ? lote.comitente : 'Sem comitente'))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lote.valorArremate)))])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.subTotalArremate)))])])], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v("Total")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-545376b5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/TableLotes.vue
// module id = 1681
// module chunks = 17